import moment from 'moment'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'

import TransitionMantineTooltip from '../../../TransitionMantineTooltip'
import { TRecoveryCode } from '../../types'

const CodeText = styled.div`
  color: #5f6368;
  font-size: 15px;
  &.used {
    text-decoration: line-through;
  }
`
type TRecoveryCodeStep = {
  recoveryCodes?: TRecoveryCode[]
}
const RecoveryCodeStep = (props: TRecoveryCodeStep): React.ReactElement => {
  const { recoveryCodes = [] } = props
  return (
    <div className="d-flex align-items-center justify-content-center w-100 flex-column">
      <div className="text-warning mt-1 font-weight-bold">
        {i18n.t(
          `fa2_save-recovery`,
          `Bitte sichern Sie die Wiederherstellungscodes an einem sicheren Ort`,
        )}
      </div>
      <div className="p-2">
        <Row>
          {recoveryCodes.map((item, index) => (
            <Col
              key={index}
              xs="6"
              className={`${
                index % 2 ? '' : 'text-right'
              }  d-flex justify-content-center w-100`}
            >
              <CodeText className={item.used_at != null ? 'used' : ''}>
                <TransitionMantineTooltip
                  tooltip={
                    item.used_at
                      ? `${i18n.t(`2fa_used-at`, `Genutzt:`)} ${moment(
                          item.used_at,
                        ).format('DD-MM-YYYY HH:mm:ss')}`
                      : ''
                  }
                >
                  {item.code}
                </TransitionMantineTooltip>
              </CodeText>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}

export default RecoveryCodeStep
